import { ImageControls } from "./ImageControls";
import { Switch } from "../ui/switch";
import { PHOTO_BOX } from "../../lib/shield";
import { BackgroundRemover, BlendControls } from "./PhotoTools";

export const PhotoPanel = ({ photo, onChange }) => (
  <div className="space-y-4">
    <ImageControls placement={photo} label="photo" aspect={PHOTO_BOX.w / PHOTO_BOX.h} testPrefix="photo"
      onChange={(p) => onChange({ ...photo, ...p, ...(p.file && p.file !== photo.file && !p.crop ? { original: null } : {}) })} />
    {photo.file && <BackgroundRemover photo={photo} onChange={onChange} />}
    {photo.file && <div className="border-t border-slate-200 pt-4"><BlendControls photo={photo} onChange={onChange} /></div>}
    <label className="flex items-center justify-between border-t border-slate-200 pt-4 text-sm font-bold">
      <span>Fade photo into background<span className="block text-xs font-normal text-slate-500">Softens the bottom edge behind the name.</span></span>
      <Switch checked={photo.fade} onCheckedChange={(fade) => onChange({ ...photo, fade })} data-testid="photo-fade-switch" />
    </label>
    <p className="bg-slate-100 p-3 text-xs text-slate-600"><b>Tip:</b> upload a transparent PNG cut-out and the player will stand directly over your chosen background.</p>
  </div>
);
